import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="users--user"
export default class extends Controller {
  static targets = ["table"]

  edit(event) {
    const row = event.currentTarget;
    const url = row.dataset.editUrl;
    Turbo.visit(url, { frame: 'user-form' });
    this.resetSelectedEntry();
    row.classList.add('selected');
    this.selectedAccount(event);
  }

  resetSelectedEntry() {
    this.tableTarget
        .querySelectorAll('tr')
        .forEach(tr => tr.classList.remove('selected'));
  }

  selectedAccount(event) {
    this.element.querySelectorAll('.tblwrap .active').forEach(b => b.classList.remove('active'))
    this.element.querySelectorAll(".tblwrap .btn")
    .forEach(btn => btn.classList.remove("active"))
    event.currentTarget.classList.add("active")
  }
}
